import store from '../store'
import router from '../router'

const logError = (isLogError, error, transactionId) => {
  if (isLogError) {
    return store.dispatch('logs/logError', {
      message: error.message,
      stackTrace: error.customStack,
      innerException: error.inner,
      transactionId,
      level: 'Exception',
    })
  }
  return false
}

const handleError = (isHandleError, error, transactionId) => {
  if (isHandleError) {
    const routeData = {
      name: 'error',
    }
    if (transactionId) {
      routeData.query = { transactionId }
    }

    return router.push(routeData).catch(e => {
      console.info(e)
    })
  }
  return false
}

const ExceptionPlugin = {}
ExceptionPlugin.install = function(Vue) {
  Vue.prototype.$handleException = async function handleException({
    error,
    isLogError = true,
    isHandleError = true,
    transactionId = '',
  }) {
    await logError(isLogError, error, transactionId)
    await handleError(isHandleError, error, transactionId)
  }
}

export default ExceptionPlugin
